import StepButton from '../../common/StepButton';
import CustomModal from '../CustomModal';
import classes from './ActionModal.module.scss';

function ActionModal({
    open,
    onClose,
    title,
    desc,
    cancelText,
    actionText,
    onAction,
    isActionLoading,
    onlyAction,
    isActionRed,
    ...props
}) {

    const getActionText = () => {
        if(actionText) return actionText;

        if(isActionRed) return 'Delete';

        return 'Okay';
    }
    return (
        <CustomModal
            modalOpen={open}
            setModalOpen={() => onClose()}
            modaltitle={title}
            modaltitleCSS={classes.actionModal__title}
            className={classes.actionModal}
            {...props}
            modalBody={
                <>
                    <div className={classes.actionModal__body}>
                        <p>{desc}</p>
                        {onlyAction ? (
                            <StepButton
                                label={getActionText()}
                                onClick={() => {
                                    onAction();
                                }}
                                isLoading={isActionLoading}
                                disabled={isActionLoading}
                                blue={!isActionRed}
                                red={isActionRed}
                            />
                        ) : (
                            <div className={classes.actionModal__actions}>
                                <StepButton
                                    gray
                                    label={cancelText || 'Cancel'}
                                    onClick={() => {
                                        onClose();
                                    }}
                                />
                                <StepButton
                                    label={getActionText()}
                                    onClick={() => {
                                        onAction();
                                    }}
                                    isLoading={isActionLoading}
                                    disabled={isActionLoading}
                                    blue={!isActionRed}
                                    red={isActionRed}
                                />
                            </div>
                        )}
                    </div>
                </>
            }
        />
    );
}
export default ActionModal;
